import { Model, RailsFormat } from "./model"
import { MatrixClass } from "./matrix-class"
import { Term } from "./term";
import { Course } from "./course";
import { Window } from "./window";
import { Campus } from "./campus";

export class Workshop extends Model implements RailsFormat {

  constructor(
    public id?: number,
    public termId?: number,
    public courseIds: number[] = [],
    public windowIds: number[] = [],
    public displayName: string = null,
    public note: string = null,
    public createdAt: Date = null,
    public updatedAt: Date = null,

    public term: Term = null,
    public courses: Course[] = [],
    public windows: Window[] = [],
    public uniqueCampuses: Campus[] = [],
  ) {
    super()
  }

  static clone(obj: any) {
    const workshop = new this()

    if (obj.id) { workshop.id = obj.id }
    if (obj.termId) { workshop.termId = obj.termId }
    if (obj.courseIds) { workshop.courseIds = obj.courseIds }
    if (obj.windowIds) { workshop.windowIds = obj.windowIds }
    if (obj.displayName) { workshop.displayName = obj.displayName }
    if (obj.note) { workshop.note = obj.note }
    if (obj.createdAt) { workshop.createdAt = new Date(obj.createdAt) }
    if (obj.updatedAt) { workshop.updatedAt = new Date(obj.updatedAt) }

    if (obj.term) { workshop.term = Term.clone(obj.term) }

    if (obj.windows && obj.windows.length > 0) {
      obj.windows.forEach((w: any) => {
        workshop.windows.push(Window.clone(w))
      })
    }

    if (obj.courses && obj.courses.length > 0) {
      obj.courses.forEach((c: any) => {
        workshop.courses.push(Course.clone(c))
      })
    }

    workshop.windows.forEach((w) => {
      const isPresent = workshop.uniqueCampuses.find(c => c.id == w.campusId)
      if (!isPresent) { workshop.uniqueCampuses.push(w.campus) }
    })

    return workshop
  }

  serializeForRails(): any {
    const response: any = Object.assign({}, this) 

    if (this.id === 0) { response.id = null }

    if (response.windows && response.windows.length > 0) {
      response.windowsAttributes = response.windows.map((w: Window) => {
        return Window.clone(w).serializeForRails()
      })
    }
    delete response.windows

    return response
  }

}




// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/workshop.ts